import React, { useState } from 'react';
import { Box } from '@mui/material';
import ServicesWrapper from './Services/index';
import GeneralResultsWrapper from './GeneralResults';
import ExitsWrapper from './Exits';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../../Common/ChartsContainer'; 

const renderContent = (activeIndex) => {
    switch (activeIndex) {
        case 0:
            return <GeneralResultsWrapper />;
        case 1:
            return <ServicesWrapper />;
        case 2:
            return <ExitsWrapper />;
        default:
            return null;
    }
};

const titleMap = {
    [`0`]: 'Resultados Gerais',
    [`1`]: 'Atendimentos',
    [`2`]: 'Saídas'
};

const Services = ({ setActiveIndex }) => {
    const [activeIndexLocal, setActiveIndexLocal] = useState(0);

    const handleHomeClick = () => {
        if (setActiveIndex) {
            setActiveIndex(0); 
        }
        setActiveIndexLocal(0); 
    };

    const menus = [
        {
            title: 'Resultados Gerais',
            onclick: () => setActiveIndexLocal(0),
            active: activeIndexLocal === 0
        },
        {
            title: 'Atendimentos',
            onclick: () => setActiveIndexLocal(1),
            active: activeIndexLocal === 1
        },
        {
            title: 'Saídas',
            onclick: () => setActiveIndexLocal(2),
            active: activeIndexLocal === 2
        }
    ];

    return (
        <Box className="services-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[`${activeIndexLocal}`]} 
                    className="services-container-dashboards"
                >
                    {renderContent(activeIndexLocal)}
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default Services;